var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activity && _vm.status)?_c('form-upload-v2-csdm-scopes-table',{attrs:{"activity":_vm.activity,"status":_vm.status,"title":"ALCANCE DE LA ACREDITACIÓN SOLICITADA","subtitle":_vm.$store.getters.getTag('2.2.1.S'),"footer":_vm.$store.getters.getTag('2.2.1.F')}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }